import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './state';
import { reduceNavigation } from './navigation/reducer';
import { reduceUser } from './user/reducer';

export const reducers: ActionReducerMap<AppState> = {
    navigation: reduceNavigation,
    user: reduceUser
};
